export default __webpack_public_path__ + "static/media/Advert.9836a7c2.png";